import { actionTypes } from "../actions/BulkEditAction";
import { SortTypes } from "../../util/table-view/TableTypes";
import { defaultResultsPerPage } from "../Types";

const initialState = {
  job: {
    job_id: null,
    selected_tracks: [],
    selected_albums: [],
    albumTracksProdId: [],
    album_meta: {},
    track_meta: {},
    track_common_updates: {},
    track_specific_updates: {},
    album_common_updates: {},
    album_specific_updates: {},
    type: null,
    session_name: null,
    org_id: null,
  },
  validationErrors: {
    track_common_validation: {},
    track_specific_validation: {},
    album_common_validation: {},
    album_specific_validation: {},
  },
  disabledField: false,
  loading: false,
  posting: { busy: false, message: "", errors: null },
  query: {
    order: SortTypes.desc,
    orderBy: "date_last_edited",
    page: 0,
    size: defaultResultsPerPage,
    q: "",
    filters: [],
  },
  errors: null,
  filledValues: false,
};

export default function (state = initialState, action) {

  const isDisabledField = (validationErrors) => 
    Object.keys(validationErrors.track_common_validation ?? {}).length > 0 ||
    Object.keys(validationErrors.track_specific_validation ?? {}).length > 0 ||
    Object.keys(validationErrors.album_common_validation ?? {}).length > 0 ||
    Object.keys(validationErrors.album_specific_validation ?? {}).length > 0;

  const areValuesFilled = (job) =>
    Object.keys(job.track_common_updates ?? {}).length > 0 ||
    Object.keys(job.track_specific_updates ?? {}).length > 0 ||
    Object.keys(job.album_common_updates ?? {}).length > 0 ||
    Object.keys(job.album_specific_updates ?? {}).length > 0;

  switch (action.type) {
    case actionTypes.POSTING:
      return {
        ...state,
        posting: {
          busy: true,
          message: action.payload,
          errors: null,
        },
      };
    case actionTypes.POST_OK:
      return {
        ...state,
        filledValues: false,
        posting: {
          busy: false,
          message: "",
          errors: null,
        },
      };
    case actionTypes.SET_ERROR:
      return {
        ...state,
        disabledField: true,
        posting: {
          busy: true,
          message: null,
          errors: action.payload,
        },
      };
    case actionTypes.POST_ERROR:
      return {
        ...state,
        posting: {
          busy: true,
          message: "",
          errors: action.payload,
        },
      };

    case actionTypes.LOADING:
      return {
        ...state,
        loading: true,
      };

    case actionTypes.VALUES_FILLED:
      return {
        ...state,
        filledValues: true,
      };

    case actionTypes.JOB_EDIT_ITEM:
      return {
        ...state,
        filledValues: areValuesFilled(action.payload),
        job: action.payload,
      };

    case actionTypes.GET_DATA_BY_ID:
      return {
        ...state,
        loading: false,
        job: {
          job_id: action.payload.job_id,
          albumTracksProdId: action.payload.albumTracksProdId,
          album_meta: action.payload.album_meta,
          track_meta: action.payload.track_meta,
          track_common_updates: action.payload.track_common_updates,
          track_specific_updates: action.payload.track_specific_updates,
          album_common_updates: action.payload.album_common_updates,
          album_specific_updates: action.payload.album_specific_updates,
          type: action.payload.type,
          org_id: action.payload.org_id,
          id: action.payload.id,
        },
      };

    case actionTypes.UPLOAD_ARTWORK_OK:
      return {
        ...state,
        loading: false,
        posting: {
          busy: false,
          message: null,
          errors: null,
        },
      };
    case actionTypes.STOP_ERROR:
      return {
        ...state,
        disabledField: isDisabledField({}),
        posting: {
          busy: false,
          message: null,
          errors: null,
        },
      };

    case actionTypes.VALIDATION_ITEM:
      return {
        ...state,
        disabledField: isDisabledField(action.payload),
        validationErrors: action.payload,
      };

    default:
      return state;
  }
}
